import { ParentTaskModel } from "@/components";

/**
 * * Модель очереди задач
 */
export class QueueModel {
  /**ID задачи */
  Id!: string;
  /**Имя */
  Name!: string;
  /**Кол-во задач */
  TasksCount: number = 0;
  /**Родительская задача */
  ParentTask?: ParentTaskModel

  constructor(obj?: Partial<QueueModel>) {
    if (obj) Object.assign(this, obj);
  }
}
